
export enum TripStatusCd {
	CANCELLED = 'Cancelled',
	COMPLETED = 'Completed',
	DISPATCHED = 'Dispatched',
	NEW_TRIP = 'NewTrip',
	RETURNING = 'Returning'}

